import { createContext } from 'react'

export type TBranding = {
  isTgt: boolean | null
  primaryColorPalette: string | null
  secondaryColorPalette: string | null
  logoUrl: string | null
  masterDealerId: string | null
  masterDealerName: string | null
  stripe: {
    accountId: string
    requiresAction: boolean
    lastStatusUpdate: string | null
    creditPackages: unknown[] | null
  }
}

export type TSetBranding = (value: Partial<TBranding>) => void

export type TBrandingContextValue = [TBranding, TSetBranding]

export const initialBranding: TBranding = {
  isTgt: null,
  primaryColorPalette: null,
  secondaryColorPalette: null,
  logoUrl: null,
  masterDealerId: null,
  masterDealerName: null,
  stripe: {
    accountId: '',
    requiresAction: true,
    lastStatusUpdate: null,
    creditPackages: null,
  },
}

const BrandingContext = createContext<TBrandingContextValue>([
  initialBranding,
  () => undefined,
])

export default BrandingContext
